import React, { useState, useEffect } from "react";
import { FormGroup, FormControlLabel, Checkbox, FormLabel, Box } from "@mui/material";

export default function CheckboxGroup({
  label = "Select options",
  options = [],             // [{label: "A", value: "a"}, ...]
  initialSelected = [],     // fx ["a", "c"]
  onChange,                 // callback(selectedArray)
  disabled = false,         // disable hele gruppen
  isOptionDisabled,         // (value) => true/false
}) {
  const [selected, setSelected] = useState(new Set(initialSelected));

  // hvis initialSelected ændrer sig udefra, sync state
  useEffect(() => {
    setSelected(new Set(initialSelected));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelected(new Set(Array.from(initialSelected)));
  }, [initialSelected]);

  const handleToggle = (value) => {
    const newSelected = new Set(selected);
    if (newSelected.has(value)) {
      newSelected.delete(value);
    } else {
      newSelected.add(value);
    }
    setSelected(newSelected);
    if (onChange) {
      onChange(Array.from(newSelected));
    }
  };

  return (
    <Box>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            control={
              <Checkbox
                checked={selected.has(opt.value)}
                onChange={() => handleToggle(opt.value)}
                disabled={disabled || (isOptionDisabled?.(opt.value) ?? false)}
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
    </Box>
  );
}